<template>
<div class="box">
<div class="address-detail-content" :style="{'padding-bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
    <div class="content-2" >
      <div class="item-inner">
        <div class="text">收货人</div>
        <input class="txt_1" type="text" v-model.trim="addressInfo.consignee" placeholder="请填写姓名">
      </div>
      <div class="empty" />
      <div class="item-inner">
        <div class="text">手机号码</div>
        <input class="info" type="text" v-model.trim="addressInfo.expressMobile" placeholder="请填写您的手机号">
      </div>
      <div class="empty" />
      <div class="item-inner">
        <van-field
          v-model="addressInfo.province"
          name="picker"
          label="省"
          placeholder="点击选择省份"
          @click="showPicker = true"
        />
        <van-popup v-model:show="showPicker"
                   round
                   position="bottom">
          <van-picker
            show-toolbar
            :columns="provinceOptions"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>
      <div class="item-inner">
        <van-field
          v-model="addressInfo.city"
          name="picker"
          label="市"
          placeholder="点击选择市"
          @click="showCityPicker = true"
        />
        <van-popup v-model:show="showCityPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="cityOptions"
            @confirm="onConfirm2"
            @cancel="showCityPicker = false"
          />
        </van-popup>
      </div>
      <div class="empty" />
      <div class="item-inner">
        <div class="text">*街道(不包含省市)</div>
        <textarea class="info" v-model.trim="addressInfo.street" placeholder="请填写街道信息"></textarea>
      </div>
<!--      <div class="empty" />
      <div class="item-inner">
        <span class="text_1">设为默认地址</span>
        <div class="label-switch">
          <input type="checkbox"  v-model="expressInfo.isDefault">
          <div class="checkbox"></div>
        </div>
      </div>-->
    </div>
</div>

  <div class="footer">
    <div class="footer-content">
      <div class="del-btn" @click="delAddress"><span class="tag">删除</span></div>
      <div class="sub-btn"  @click="submit"><span class="tag">保存</span></div>
    </div>
    <footer-placeholder></footer-placeholder>
  </div>
</div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import FooterPlaceholder from '../components/FooterPlaceholder'
  import emkt from '../../emkt'
export default {
    components: {FooterPlaceholder},
    created () {
      // var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + (this.expressInfo.district === undefined ? '' : this.expressInfo.district)
      // $('#city-picker').val(express)
    },
    data () {
      return {
        href: 'javascript:;',
        addressInfo: {},
        provinceOptions: [],
        cityOptionsMap: {},
        cityOptions: [],
        showPicker: false,
        showCityPicker: false
      }
    },
    mounted () {
      // $('#city-picker').cityPicker({toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
      // })
      // console.log('sss', this.expressInfo)
      // var express = this.expressInfo.province + ' ' + this.expressInfo.city + ' ' + (this.expressInfo.district === undefined ? '' : this.expressInfo.district)
      // $('#city-picker').val(express)
      let _this = this
      _this.addressInfo = this.expressInfo
      _this.gcapi('getBProvices').then((response) => {
        console.log(response)
        let data = response.body.result
        for (let i in data) {
          _this.provinceOptions.push({text: data[i].name, value: data[i].name})
          let city = []
          for (let y in data[i].cities) {
            city.push({text: data[i].cities[y].name, value: data[i].cities[y].name})
          }
          _this.cityOptionsMap[data[i].name] = city
        }
        this.cityOptions = _this.cityOptionsMap[_this.addressInfo.province]
        console.log(_this.provinceOptions, _this.cityOptionsMap)
      })
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ]),
      'expressInfo': function () {
        return JSON.parse(this.$route.query.address)
      }
    },
    methods: {
      ...mapMutations([
        'EXPRESSADDRESS_UPDATE'
      ]),
      onConfirm2 (data) {
        this.addressInfo.city = data.value
        this.showCityPicker = false
      },
      onConfirm (data) {
        this.addressInfo.province = data.value
        this.cityOptions = this.cityOptionsMap[data.value]
        this.showPicker = false
      },
      submit () {
        var _this = this
        let params = {}
        params.customerNo = this.sessionInfo.customerInfo.customerNo
        params.creator = this.sessionInfo.customerInfo.customerName
        params.operator = this.sessionInfo.customerInfo.customerName
        params.expressAddressGuid = _this.addressInfo.expressAddressGuid
        params.isDefault = _this.addressInfo.isDefault
        params.consignee = _this.addressInfo.consignee.replace(/\s/g, '')
        params.expressMobile = _this.expressInfo.expressMobile
        params.province = _this.addressInfo.province
        params.city = _this.addressInfo.city
        params.street = _this.addressInfo.street
        // params.district = _this.addressInfo.district
        params.addressSource = emkt.ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT
        _this.gcapi('createOrUpdateAddress', params).then((response) => {
          if (response.body.code === 0) {
            this.$weui.toast('修改成功', 1500)
            // $.toast('修改成功')
            _this.gotolast()
          }
          if (response.body.code === 1) {
            this.$weui.topTips('出错')
            // $.toast('出错')
          }
        })
      },
      delAddress () {
        var _this = this
        _this.href = 'javascript:window.history.back()'
        _this.gcapi('gcwwwifc/updateAddressStatus', {
          'expressAddressGuid': _this.expressInfo.expressAddressGuid
        }).then((response) => {
          if (response.body.code === 0) {
            this.$weui.toast('删除成功', 1500)
            // $.toast('删除成功')
            _this.gotolast()
          } else {
            this.$weui.topTips('出错')
            // $.toast('出错')
          }
        }, (response) => {
          this.$weui.topTips('请求错误')
          // $.toast('请求错误')
        })
      },
      gotolast () {
        // window.history.go(-1)
        this.$router.push({name: 'WeappAddress', query: {from: this.$route.query.from}, params: {order: this.$route.params.order, addressType: this.$route.params.addressType}})
      }
    }
  }
</script>
<style>
.van-cell__title {
  font-width: 800;
  color: #424242;
  font-size: 14px;
  font-weight: bold;
}
.van-field__body van-field__control {
  color: #979797;
  font-size: 14px;
  font-weight: 400;
}
</style>
<style scoped>
input {
  border: 0;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  width:100%;
  line-height: 25px;
}

textarea {
  border: none;
  resize: none;
  cursor: pointer;
  word-break:break-all;
  margin-top: 13px;
}
.item-inner .text {
  width: 140px;
}
.box {
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #fafafa;
  height: 100vh;
  padding: 10px;
  padding-bottom: 0;
}

.content-2 {
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 10px;
  border: 0.5px solid rgba(239, 238, 243, 1);
  background-color: #ffffff;
  width: 100%;
  height: 302px;
  margin-bottom: 10px;
}

.text {
  opacity: 1;
  line-height: 20px;
  margin-right: 20px;
  white-space: nowrap;
  color: #424242;
  font-size: 14px;
  font-weight: bold;
}

.text_1 {
  opacity: 1;
  line-height: 20px;
  white-space: nowrap;
  color: #424242;
  font-size: 14px;
  font-weight: bold;
}

.txt_1 {
  opacity: 1;
  line-height: 20px;
  margin-left: 15px;
  white-space: nowrap;
  color: #979797;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}

.empty {
  position: relative;
  margin-top: 19px;
  border-top: 0.5px solid rgba(239, 238, 243, 1);
  right: 0;
  height: 1px;
  margin-left: 15px;
}

.info {
  opacity: 1;
  height: 40px;
  color: #979797;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}

.item-inner {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
  width: 100%;
  height: 20px;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 15px;
}

.info_1 {
  opacity: 1;
  line-height: 20px;
  white-space: nowrap;
  color: #979797;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  margin-left: -4px;
}

.image {
  font-size: 12px;
  position: absolute;
  color: #4444448a;
  right: 15px;
}

.footer {
  position: fixed;
  bottom:0;
  left: 0;
  width: 100%;
  font-size: 14px;
  background-color: #fff;
}

.footer-content {
  display: flex;
  align-items: center;
  align-self: center;
  flex-direction: row;
  background-color: #ffffff;
  width: 100%;
  height: 58px;
  padding: 0px 10px;
}

.del-btn {
  display: flex;
  justify-content: center;
  border-radius: 22px;
  background-color: #fe654d;
  width: 172px;
  height: 44px;
  margin-right: 11px;
  margin-left: 10px;
}

.sub-btn {
  display: flex;
  justify-content: center;
  border-radius: 22px;
  background-color: #5878fa;
  width: 172px;
  height: 44px;
  margin-right: 10px;
}

.tag {
  color: #ffffff;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  position: relative;
  margin-top: 12px;
  margin-bottom: 12px;
}

.label-switch input[type="checkbox"]:checked + .checkbox {
  background: #1677ff;
}
</style>



// WEBPACK FOOTER //
// AddressModify.vue?a8aadad8